<template>
  <el-card shadow="never" class="portal-eChart-box">
    <div  class="portal-common-title">
      <span>{{ title }}</span>
    </div>
    <div class="eTable-box-body">
      <div class="portal-common-table" style="padding-right: 10px; display: flex; align-items: center;">
        <!-- <el-table
            :data="tableData"
            border
            stripe
            highlight-current-row
            header-row-class-name="self-row-header"
            header-cell-class-name="self-cell-header"
            size="small"
            style="width: 100%">
            <el-table-column
              prop="label"
              label="托管时段"
              align="center">
            </el-table-column>
            <el-table-column
              prop="value"
              align="center"
              label="学生人次">
            </el-table-column>
          </el-table> -->
          <div class="flex-details-item" v-for="item in tableData" :key="item.label">
            <img :src="getImg(item.label)">
            <div>
              <span>{{item.label}}</span>
              <span>{{item.value || 0}}</span>
            </div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import request from '@/config/request.js'
const ApiHome = request.Home
export default {
  props: {
    title: { type: String, default: '' },
    
  },
  data() {
    return {
      
      tableData: [
        {
          value: '1',
          label: '午托'
        },
        {
          value: '2',
          label: '下午托'
        },
        {
          value: '3',
          label: '其他'
        }
      ],
    }
  },
  created() {
    this.getTableData()
  },
  mounted () {
  },
  methods: {
    getImg(label) {
      const imgMap = [
        '午托',
        '下午托',
        '作业托',
        '其他'
      ]
      if(imgMap.includes(label)){
        return require('@/assets/home/'+label+'.png')
      }
      return require('@/assets/home/通用.png')
    },
    getTableData() {
      ApiHome.getZoneStudentByServicePeriod.call(this, {}, (res => {
         this.tableData = res.map(item => ({
          label: item.serviceType,
          value: item.studentNum
        }))
      }))
    },
}
}
</script>

<style lang="less">
.el-card__body{
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  .portal-common-title{
    padding: 18px 20px;
    box-sizing: border-box;
  }
  .eTable-box-body {
    flex: 1;
    height: 100%;
    padding: 10px;
    box-sizing: border-box;
    .portal-common-table{
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 0 15px;
      box-sizing: border-box;
      .flex-details-item{
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        flex: 1;
        img{
          width: 42px;
          height: 42px;
          margin-right: 5px;
        }
        div{
          width: 100%;
          display: flex;
          justify-content: space-between;
          span:nth-child(1){
            font-size: 14px;
            font-weight: 500;
            color: #333333;
          }
          span:nth-child(2){
            font-size: 14px;
            font-weight: 500;
            color: #409eff;
          }
        }
      }
    }
    .portal-common-noData-eChart{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .dom-canvas{
    height: 100%;
  }
}


</style>
